import React, { ReactNode, CSSProperties } from 'react';

export type SectionHeaderProps = {
  children?: ReactNode;
  action?: ReactNode;
  style?: CSSProperties;
};

export function SectionHeader({ children, action, style }: SectionHeaderProps) {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
        padding: '0 4px 8px',
        ...style,
      }}
    >
      <div
        style={{
          fontSize: 13, fontWeight: 600, letterSpacing: '0.4px',
          color: 'var(--fg-tertiary)', textTransform: 'uppercase',
        }}
      >
        {children}
      </div>
      {action}
    </div>
  );
}

export default SectionHeader;
